import { COLORS } from "shared/style/colors";

const colorsList = [
  COLORS.C_RAND_0D1,
  COLORS.C_RAND_5CC,
  COLORS.C_RAND_5FD,
  COLORS.C_RAND_BF8,
  COLORS.C_RAND_BFF,
  COLORS.C_RAND_DD7,
  COLORS.C_RAND_DFF,
];

export const getRandomColor = () => {
  return colorsList[Math.floor(Math.random() * colorsList.length)];
};
